import api from '../utils/axiosConfig'

export interface PostMonthlyClaimParams {
  transaction_id: string
  user_id: string
}

export interface PostMonthlyClaimResponse {
  status: number
  system?: string
  message: string
}

export const postMonthlyClaim = async (
  params: PostMonthlyClaimParams,
): Promise<PostMonthlyClaimResponse> => {
  const res = await api.post('/bonus/claim/monthly', params)
  return res.data
}
